// extracted by mini-css-extract-plugin
export default {"Emojify":"bcc_a bie_g"};